/**
 * Helper utilities for QuestionsForm.jsx
 * Keep functions pure to improve readability and make behaviors easier to reason about.
 */

// Mapping jumlah input untuk tiap clickable_type
export const CLICKABLE_LENGTH_BY_TYPE = {
  triangle: 4,
  box: 8,
  boxhard: 16,
};

export function makeEmptyStrings(length) {
  return Array.from({ length }, () => '');
}

export function isSameArray(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  return a.every((v, i) => v === b[i]);
}

// Shuffle helper khusus sequential: shuffle array, best-effort supaya beda dari original
export function shuffleArrayEnsureDifferent(arr, maxAttempts = 5) {
  const base = Array.isArray(arr) ? [...arr] : [];
  if (base.length <= 1) return base;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const next = [...base];

    // Fisher–Yates shuffle
    for (let i = next.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = next[i];
      next[i] = next[j];
      next[j] = tmp;
    }

    if (!isSameArray(next, base)) return next;
  }

  // Kalau kebetulan selalu sama (rare), return base
  return base;
}

export function getShapeVariant(clickableType) {
  return clickableType || 'square';
}

export function getShapePreset(answers /* clickableType */) {
  if (!Array.isArray(answers) || answers.length === 0) return [];
  // convert nilai string ke number, default 0 jika tidak valid
  return answers.map((val) => {
    const num = parseInt(val, 10);
    return Number.isFinite(num) ? num : 0;
  });
}